import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../../Buttons/StatusBadgeWithDropdown';

const data = [
    {
        Action: '--',
        amc: '--',
        assetCategory: '--',
        assetCondition: '--',
        assetStatus: '--',
        assignedTo: '--',
        comments: '--',
        createdDate: '--',
        deActivatedDate: '--',
        department: '--',
        description: '--',
        issueDate: '--',
        location: '--',
        manufacturedDate: '--',
        modelNumber: '--',
        password: '--',
        physicalVerificationStatus: '--',
        purchaseDate: '--',
        reImageDate: '--',
        repairLocation: '--',
        repairRemark: '--',
        repairType: '--',
        repairVendor: '--',
        serialNumber: '--',
        serviceDate: '--',
        serviceTag: '--',
        systemId: '--',
        Status: 'Active',
    },
];

const columns = [
    { id: 'Action', label: 'ACTION', align: 'left', minWidth: '80px' },
    { id: 'amc', label: 'AMC', align: 'left', minWidth: '80px' },
    { id: 'assetCategory', label: 'ASSET CATEGORY', align: 'left', minWidth: '160px' },
    { id: 'assetCondition', label: 'ASSET CONDITION', align: 'left', minWidth: '170px' },
    { id: 'assetStatus', label: 'ASSET STATUS', align: 'left', minWidth: '150px' },
    { id: 'assignedTo', label: 'ASSIGNED TO', align: 'left', minWidth: '140px' },
    { id: 'comments', label: 'COMMENTS', align: 'left', minWidth: '120px' },
    { id: 'createdDate', label: 'CREATED DATE', align: 'left', minWidth: '150px' },
    { id: 'deActivatedDate', label: 'DEACTIVITED DATE', align: 'left', minWidth: '170px' },
    { id: 'department', label: 'DEPARTMENT', align: 'left', minWidth: '130px' },
    { id: 'description', label: 'DESCRIPTION', align: 'left', minWidth: '130px' },
    { id: 'issueDate', label: 'ISSUE DATE', align: 'left', minWidth: '120px' },
    { id: 'location', label: 'LOCATION', align: 'left', minWidth: '120px' },
    { id: 'manufacturedDate', label: 'MANUFACTURED DATE', align: 'left', minWidth: '200px' },
    { id: 'modelNumber', label: 'MODEL NUMBER', align: 'left', minWidth: '150px' },
    { id: 'password', label: 'PASSWORD', align: 'left', minWidth: '130px' },
    { id: 'physicalVerificationStatus', label: 'PHYSICAL VERIFICATION STATUS', align: 'left', minWidth: '260px' },
    { id: 'purchaseDate', label: 'PURCHASE DATE', align: 'left', minWidth: '160px' },
    { id: 'reImageDate', label: 'REIMAGE DATE', align: 'left', minWidth: '140px' },
    { id: 'repairLocation', label: 'REPAIR LOCATION', align: 'left', minWidth: '170px' },
    { id: 'repairRemark', label: 'REPAIR REMARK', align: 'left', minWidth: '160px' },
    { id: 'repairType', label: 'REPAIR TYPE', align: 'left', minWidth: '130px' },
    { id: 'repairVendor', label: 'REPAIR VENDOR', align: 'left', minWidth: '150px' },
    { id: 'serialNumber', label: 'SERIAL NUMBER', align: 'left', minWidth: '150px' },
    { id: 'serviceDate', label: 'SERVICE DATE', align: 'left', minWidth: '140px' },
    { id: 'serviceTag', label: 'SERVICE TAG', align: 'left', minWidth: '130px' },
    { id: 'systemId', label: 'SYSTEM ID', align: 'left', minWidth: '120px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '120px', },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const LaptopMasterTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                    {column.label}
                                    {column.sortable !== false && (
                                        <IconButton
                                            size="small"
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            <img src={SortIcon} alt="Sort" />
                                        </IconButton>
                                    )}
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((customer) => (
                        <TableRow key={customer.id}>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                    {column.id === 'Status' ? (
                                        <span
                                            className={`status-badge ${customer.Status === 'Active' ? 'complete-status no-dropdown-badge' : 'cancel-status no-dropdown-badge'}`}
                                        >
                                            {customer.Status}
                                        </span>
                                    ) : column.id === 'action' ? (
                                        <SbActionDropdownButton
                                            options={[{ type: 'Edit' }, { type: 'View' }]}
                                            openAddModal={props.handleOpenModal}
                                            addBulkModel={props.handleOpenViewModal}
                                        />
                                    ) : (
                                        customer[column.id]
                                    )}
                                </TableCell>

                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                    Ascending to Descending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                    Descending to Ascending
                </MenuItem>
            </Menu>
        </TableContainer>
    );
};

export default LaptopMasterTable;
